module.exports = __webpack_public_path__ + "img/maestro.649a2f0d.svg";